import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from '@/shared/components/ProtectedRoute';
import GuestRoute from '@/shared/components/GuestRoute';
import Index from '@/domains/Index';
import SLAPage from '@/app/legal/SLAPage';
import UserGuidePage from '@/app/legal/user-guide/UserGuidePage';
import LoginPage from '@/app/auth/LoginPage';
import ForgotPasswordPage from '@/app/auth/ForgotPasswordPage';
import ResetPasswordPage from '@/app/auth/ResetPasswordPage';
import VerifyOTPPage from '@/app/auth/VerifyOTPPage';
import { CatchAllRoute } from '@/app/shared/CatchAllRoute';
import AccountDetailsPage from '@/domains/accounts/pages/AccountDetailsPage';
import ServiceLineDetailsPage from '@/domains/service-lines/pages/ServiceLineDetailsPage';
import { ROUTES } from '@/config/routeConfig';
import CustomerDetailsPage from '@/domains/customers/pages/CustomerDetailsPage';
import CustomerServiceLineDetailsPage from '@/domains/customers/pages/CustomerServiceLineDetailsPage';

/**
 * Tenant (business operator) shell: auth + account-scoped navigation.
 * Users without SUPER_ADMIN in `global-roles` are routed here via `AppShellGate`.
 */
export function TenantRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path={ROUTES.LOGIN} element={<GuestRoute><LoginPage /></GuestRoute>} />
      <Route path={ROUTES.FORGOT_PASSWORD} element={<GuestRoute><ForgotPasswordPage /></GuestRoute>} />
      <Route path={ROUTES.RESET_PASSWORD} element={<GuestRoute><ResetPasswordPage /></GuestRoute>} />
      <Route path={ROUTES.VERIFY} element={<GuestRoute><VerifyOTPPage /></GuestRoute>} />
      <Route
        path={ROUTES.ACCOUNT_DETAILS_TAB.replace(':tabSlug', ':tabSlug?')}
        element={
          <ProtectedRoute>
            <AccountDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.SERVICE_LINE_DETAILS}
        element={
          <ProtectedRoute>
            <ServiceLineDetailsPage mode="tenant" />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CUSTOMER_SERVICE_LINE_DETAILS}
        element={
          <ProtectedRoute>
            <CustomerServiceLineDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CUSTOMER_DETAILS_TAB.replace(':tabSlug', ':tabSlug?')}
        element={
          <ProtectedRoute>
            <CustomerDetailsPage shouldAllowAccountChange={false} />
          </ProtectedRoute>
        }
      />
      <Route path={ROUTES.SLA} element={
        <ProtectedRoute>
          <SLAPage />
        </ProtectedRoute>
      }
      />
      <Route path={ROUTES.USER_GUIDE} element={
        <ProtectedRoute>
          <UserGuidePage />
        </ProtectedRoute>
      }
      />
      <Route path="*" element={<CatchAllRoute />} />
    </Routes>
  );
}
